import React from 'react';
import SelectedCellMap from './SelectedCellMap';

export const SelectActiveAddressesMap = ({}) => {
  const showOPSDetailsOnMap = false;
  const showAddressLocations = true;

  return (
    <SelectedCellMap
      showOPSDetails={showOPSDetailsOnMap}
      showAddressLocations={showAddressLocations}
    />
  );
};

export default SelectActiveAddressesMap;
